export default "__VITE_ASSET__0829ea32__"